import { Accordion } from "react-bootstrap";
import "./SubmitLead.scss";

export default function LeadList({
  leadListData,
  customerType,
  leadReason,
  operatorList,
}) {
  const filterData = (list, single) => {
    let temp = [];
    list.filter((l) => {
      single.filter((s) => {
        if (l.index == s) {
          temp.push(l);
        }
      });
    });
    return temp;
  };

  return (
    <Accordion className="p-3 mx-auto mt-5 shadow lead-list">
      <Accordion.Item eventKey="0">
        <Accordion.Header style={{ backgroundColor: "transparent" }}>
          لیست سرنخ
        </Accordion.Header>
        <Accordion.Body>
          {leadListData?.map((l) => {
            return (
              <div className="d-flex flex-wrap list-container my-4 p-1">
                <div>
                  <div className="title-list">جنسیت‌اول</div>
                  <div className="txt-list">
                    {" "}
                    {l.jender1 == "1" ? "آقا" : l.jender1 == "2" ? "خانم" : ""}
                  </div>
                </div>
                <div>
                  <div className="title-list">نام‌و‌نام‌خانوادگی‌اول</div>
                  <div className="txt-list"> {l.fullname1}</div>
                </div>
                <div>
                  <div className="title-list">موبایل‌اول</div>
                  <div className="txt-list"> {l.mobile1}</div>
                </div>
                <div>
                  <div className="title-list">جنسیت‌دوم</div>
                  <div className="txt-list">
                    {" "}
                    {l.jender2 == "1" ? "آقا" : l.jender2 == "2" ? "خانم" : ""}
                  </div>
                </div>
                <div>
                  <div className="title-list">نام‌و‌نام‌خانوادگی‌دوم</div>
                  <div className="txt-list"> {l.fullname2}</div>
                </div>
                <div>
                  <div className="title-list">موبایل‌دوم</div>
                  <div className="txt-list"> {l.mobile2}</div>
                </div>
                <div>
                  <div className="title-list">نوع مشتری</div>
                  <div className="txt-list">
                    {" "}
                    {filterData(customerType, l.type.split(",")).map((c, i) => {
                      return `${c.label} ${
                        i < l.type.split(",").length - 1 ? "," : ""
                      }`;
                    })}
                  </div>
                </div>
                <div>
                  <div className="title-list">دلیل مصرف</div>
                  <div className="txt-list">
                    {" "}
                    {filterData(leadReason, l.type_of_use.split(",")).map(
                      (c, i) => {
                        return `${c.label} ${
                          i < l.type_of_use.split(",").length - 1 ? "," : ""
                        }`;
                      }
                    )}
                  </div>
                </div>
                <div>
                  <div className="title-list">اپراتور</div>
                  <div className="txt-list">
                    {" "}
                    {
                      operatorList.filter((o) => o.value == l.operator_id)[0]
                        ?.label
                    }
                  </div>
                </div>
              </div>
            );
          })}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    // <div className="p-3 mx-auto mt-5 shadow lead-list position-relative">
    //   <div className="text-center py-1 fw-bold fs-5 position-absolute  title px-3 title">
    //     لیست سرنخ
    //   </div>

    //   {leadListData.map((l) => {
    //     return (
    //       <div className="d-flex flex-wrap list-container my-4 p-1">
    //         <div>
    //           <div className="title-list">جنسیت‌اول</div>
    //           <div className="txt-list">
    //             {" "}
    //             {l.jender1 == "1" ? "آقا" : "خانم"}
    //           </div>
    //         </div>
    //         <div>
    //           <div className="title-list">نام‌و‌نام‌خانوادگی‌اول</div>
    //           <div className="txt-list"> {l.fullname1}</div>
    //         </div>
    //         <div>
    //           <div className="title-list">موبایل‌اول</div>
    //           <div className="txt-list"> {l.mobile1}</div>
    //         </div>
    //         <div>
    //           <div className="title-list">جنسیت‌دوم</div>
    //           <div className="txt-list">
    //             {" "}
    //             {l.jender2 == "1" ? "آقا" : "خانم"}
    //           </div>
    //         </div>
    //         <div>
    //           <div className="title-list">نام‌و‌نام‌خانوادگی‌دوم</div>
    //           <div className="txt-list"> {l.fullname2}</div>
    //         </div>
    //         <div>
    //           <div className="title-list">موبایل‌دوم</div>
    //           <div className="txt-list"> {l.mobile2}</div>
    //         </div>
    //         <div>
    //           <div className="title-list">نوع مشتری</div>
    //           <div className="txt-list">
    //             {" "}
    //             {filterData(customerType, l.type.split(",")).map((c, i) => {
    //               return `${c.label} ${
    //                 i < l.type.split(",").length - 1 ? "," : ""
    //               }`;
    //             })}
    //           </div>
    //         </div>
    //         <div>
    //           <div className="title-list">دلیل مصرف</div>
    //           <div className="txt-list">
    //             {" "}
    //             {filterData(leadReason, l.type_of_use.split(",")).map(
    //               (c, i) => {
    //                 return `${c.label} ${
    //                   i < l.type_of_use.split(",").length - 1 ? "," : ""
    //                 }`;
    //               }
    //             )}
    //           </div>
    //         </div>
    //         <div>
    //           <div className="title-list">اپراتور</div>
    //           <div className="txt-list">
    //             {" "}
    //             {operatorList.filter((o) => o.value == l.operator_id)[0]?.label}
    //           </div>
    //         </div>
    //       </div>
    //     );
    //   })}
    // </div>
  );
}
